// Adapts an IB podcast episode (IBPodcastEpisode.to_dict) to the YouTube
// Video shape that VideoCard expects, so advisor episodes render with the
// exact same card as regular podcast videos.
export default function advisorEpisodeToVideoDetail(episode) {
  return {
    id: `advisor-${episode.id}`,
    title: episode.title,
    date_published: episode.published_at,
    view_count: episode.view_count,
    length: episode.duration_seconds,
    is_watched: true,
    authors: [],
    categories: [],
    thumbnails: {
      small: episode.thumbnail_url,
      medium: episode.thumbnail_url,
      large: episode.thumbnail_url,
    },
  };
}
